<template>
  <div class="wrapper">
    <div class="main visual-2 enter-phone">
      <Header :backRoute="'/'" />
      <div class="vis4-inr1">
        <h1>Enter Your Phone Number</h1>
        <form class="namesearch" id="smsform" action="visual-5" method="get">
          <label for="phone">Enter Your Phone Number</label>
          <input
            type="number"
            id="phone"
            name="phone"
            placeholder="123 456 7890"
            required
          />
          <button type="submit">Next</button>
        </form>
      </div>
      <FooterView />
    </div>
  </div>
</template>

<script>
import FooterView from "@/layout/Footer.vue";
import Header from "@/layout/Header.vue";
export default {
  components: {
    FooterView,
    Header,
  },
  name: "EnterPhone",
};
</script>
